import { useState, useMemo } from 'react';
import buildItemsDepthMap from '../helpers/build-items-depth-map.js';

const getInitialOpenNodeIds = (items) =>
  items
    .filter((node) => node.droppable && typeof node.collapsed === 'boolean' && !node.collapsed)
    .map((node) => node.id);

const useTreeViewData = (items, rootId) => {
  const [isDragging, setIsDragging] = useState(false);
  const [openNodeIds, setOpenNodeIds] = useState(() => getInitialOpenNodeIds(items));

  const itemsDepthMap = useMemo(() => buildItemsDepthMap(items, rootId), [items, rootId]);

  return {
    isDragging,
    openNodeIds,
    itemsDepthMap,
    setIsDragging,
    setOpenNodeIds,
  };
};

export default useTreeViewData;
